<script lang="ts">
  import { onMount } from "svelte";
  import { ApiService } from "../../services/api.service";
  import BlueButton from "../BlueButton.svelte";

  import FormWithLabel from "../../molecules/FormWithLabel.svelte";
  import SectionBoard from "../../molecules/SectionBoard.svelte";
  import { initImageUploadValue } from "../../atoms/forms/ImageUpload";
  import { ErrorService } from "../../services/error.service";

  let loading = false;

  let image = initImageUploadValue();

  const handleImage = (event) => {
    image = event.detail.value;
  };

  onMount(async () => {
    const client = ApiService.createClient();
    const { data } = await client.get("/settings/recruitmentImage");
    console.log(data);
    if (!data.recruitmentImage) {
      return;
    }
    image.src = data.recruitmentImage;
  });

  const save = async () => {
    const client = ApiService.createClient();

    if (image.base64) {
      try {
        loading = true;
        await client.post("/settings/recruitmentImage", {
          base64: image.base64,
        });
      } catch (e) {
        ErrorService.catch(e);
      } finally {
        loading = false;
      }
    }
  };
</script>

<SectionBoard>
  <h2 class="font-semibold">求人の設定</h2>

  <div class="mt-6">
    <FormWithLabel
      label="求人デフォルト画像"
      input={handleImage}
      file={image}
      inputType="image"
    />
  </div>

  <BlueButton rounded klass="mt-4" click={save} {loading}>更新する</BlueButton>
</SectionBoard>
